import { createRoot } from 'react-dom/client';
import { App } from './App';
import { startAnalytics } from './analytics';
import './styles/base.css';
import './styles/components.css';
import './styles/home.css';
import './styles/responsive.css';
import './styles/join.css';
startAnalytics();
createRoot(document.getElementById('app')!).render(<App />);
